import { Data2 } from "../../../features/data-types"
import { useTransactionActions } from "../actions/transactionActions"
import { useTransactionBuilders } from "../builders/transactionBuilders"

export const useTransactionService = () => {
    const { buildTransaction } = useTransactionBuilders()
    
    const { saveTransaction } = useTransactionActions()

    const createTransaction = async (transactionData: Data2) => {
        const transaction = buildTransaction(transactionData)
        return saveTransaction(transaction)
    }

    return {
        createTransaction
    }
}
